import { gqlClient } from '../../components/AppProvider';
import {
  UpdateTenantAccountAcceptedPaymentTypesInput,
  UpdateTenantAccountFeatureFlagsInput,
  UpdateTenantAccountSettingsInput,
} from '../../gql-types.generated';
import { queryTenantAccountById } from '../../gql/QueryTenantAccountById';
import { mutationUpdateTenantAccountSettings } from '../../gql/MutationUpdateTenantAccountSettings';
import { mutationUpdateTenantAccountAcceptedPaymentTypes } from '../../gql/MutationUpdateTenantAccountAcceptedPaymentTypes';
import { mutationUpdateTenantAccountFeatureFlags } from '../../gql/MutationUpdateTenantAccountFeatureFlags';
import { AppThunk } from '../../store';
import { decrementRequestsInFlight, incrementRequestsInFlight } from '../app/AppSlice';
import {
  fetchTenantStart,
  fetchTenantSuccess,
  fetchTenantError,
  updateTenantStart,
  updateTenantSuccess,
  updateTenantError,
  updatePaymentTypesStart,
  updatePaymentTypesSuccess,
  updatePaymentTypesError,
  updateFeatureFlagsStart,
  updateFeatureFlagsSuccess,
  updateFeatureFlagsError,
} from './TenantSettingsSlice';

export const fetchTenantById =
  (tenantId: string): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    dispatch(fetchTenantStart());
    try {
      const result = await queryTenantAccountById(gqlClient, tenantId);
      if (result) dispatch(fetchTenantSuccess(result));
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(fetchTenantError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };

export const updateTenantSettings =
  (tenantId: string, input: UpdateTenantAccountSettingsInput): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    dispatch(updateTenantStart());
    try {
      await mutationUpdateTenantAccountSettings(gqlClient, tenantId, input);
      dispatch(updateTenantSuccess());
      dispatch(fetchTenantById(tenantId));
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(updateTenantError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };

export const updateTenantAcceptedPaymentTypes =
  (tenantId: string, input: UpdateTenantAccountAcceptedPaymentTypesInput): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    dispatch(updatePaymentTypesStart());
    try {
      await mutationUpdateTenantAccountAcceptedPaymentTypes(gqlClient, tenantId, input);
      dispatch(updatePaymentTypesSuccess());
      dispatch(fetchTenantById(tenantId));
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(updatePaymentTypesError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };

export const updateTenantFeatureFlags =
  (tenantId: string, input: UpdateTenantAccountFeatureFlagsInput): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    dispatch(updateFeatureFlagsStart());
    try {
      await mutationUpdateTenantAccountFeatureFlags(gqlClient, tenantId, input);
      dispatch(updateFeatureFlagsSuccess());
      dispatch(fetchTenantById(tenantId));
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(updateFeatureFlagsError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };
